<template>
  <div class="form-group">
    <p class="scroll-box-title" v-html="sanitizedFieldTitle"></p>
    <div class="form-scroll-box" v-html="sanitizedHelpText"></div>
  </div>
</template>

<script>
import InputMixin from '@/mixins/InputMixin';

/**
 * A field that renders a scroll box.
 */
export default {
  name: 'ScrollBox',
  mixins: [
    InputMixin,
  ],
  props: {
    /**
     * The Array of input values
     */
    value: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
</script>
